import { Button, Stack, Text } from "@mantine/core";
import type { ReactNode } from "react";
import type { LoginPageFooterLink } from "../LoginPage";
import type { LoginTr } from "../useLoginTranslations";
import { AuthSplitLayout } from "./AuthSplitLayout";
import { LoginFormFooter } from "./LoginForm/LoginFormFooter";

export interface LoginPendingApprovalViewProps {
  onChangeAccount: () => void;
  logo?: ReactNode;
  footerAgreement?: ReactNode;
  footerSupportLink?: LoginPageFooterLink;
  tr: LoginTr;
}

export function LoginPendingApprovalView({
  onChangeAccount,
  logo,
  footerAgreement,
  footerSupportLink,
  tr,
}: LoginPendingApprovalViewProps) {
  return (
    <AuthSplitLayout
      brandMode="pendingApproval"
      logo={logo}
      tr={tr}
      title={tr("login.pendingApproval.title", "Approval Pending")}
    >
      <Stack gap="md">
        <Text c="dimmed">
          {tr(
            "login.pendingApproval.message",
            "Your email is confirmed and your account is awaiting approval from Canucci. Please come back later or contact support if needed.",
          )}
        </Text>
        <Button onClick={onChangeAccount} fullWidth variant="outline">
          {tr("login.pendingApproval.backToSignIn", "Back to sign in")}
        </Button>
        <LoginFormFooter footerAgreement={footerAgreement} footerSupportLink={footerSupportLink} />
      </Stack>
    </AuthSplitLayout>
  );
}
